
	import {
		Component,
		Vue
	} from 'vue-property-decorator';
	import Switch from '@/components/switch.vue';
	import PageFooter from '@/components/page-footer.vue';
	import previewImg from "@/components/previewImg.vue"
	import {
		productproductSpecialList,
		productproductSpecialSave,
		productproductSpecialDelete,
		custompagecustompagelist,
		productfilterBoxList
	} from '@/api/material'
	import {
		productList,
		productCategory
	} from '@/api/supplier'
	import {
		getOssToken
	} from '@/api/user'
	import Message from '@/components/message.vue'
	import {imgHost} from '@/utils/config'
  import Dialog from '@/components/dialog.vue';
	import UploadImg from '@/components/upload-img.vue';
	import PickerDate from '@/components/picker-date.vue';
	import {
		getSearchDate,
		nextDay
	} from "@/utils/index"

	@Component({
		name: 'operation-banner',
		components: {
			PickerDate,
			PageFooter,
			'slz-switch': Switch,
			Message,
      'slz-dialog': Dialog,
			UploadImg,
			previewImg
		}
	})
	export default class OperationBanner extends Vue {
		private imgUrl = imgHost;
		private filterTime = ''
		private keyword = '';
		private isOpen = false;
		private pageNo = 1;
		private pageSize = 12;
		private list: any = [];
		private total = 0;
		private bannerIdKey = '';
		private showDialog = false;
		private currentId = 0;
		private operationShow = false
		private operationloading = false
		private loading = false
		private rowmsg:any = {
			Id:0,
			IsDisplay:true,
			Title:'',
			ImgUrl:'',
			RelationType:2,
			RelationTypeValue:'商品分类',
			StartTime:'',
			EndTime:'',
			RelationId:'',
			RelationValue:'',
			Sort:'',
			ShowStartTime:'',
			ShowEndTime:''
		}
		private token:any = {}
		private typelist:any = [
			{value:1,label:'商品关联'},
			{value:2,label:'商品分类'},
			{value:3,label:'自定义页面'},
		]
		private classityList:any = []
		private shoplist:any = []
		private renderingshow = false
		private pageList:any = []

		private mounted() {
			this.filterTime = [getSearchDate(2,false,-7)[0],getSearchDate(2)[0]].join('/')
			this.getList();
		}


		private async getcustompage(){
			try{
				let res = await custompagecustompagelist({
					PageName:'',
					Skip:0,
					Take:99999
				})
				if(res.IsSuccess){
					this.pageList = res.Result.Results
				}
			}finally{
				//
			}
		}
		private emptyTime(){
			this.filterTime = ''
			this.getList()
		}
		private async addConfirm(){
			if(!this.rowmsg.Title){
				this.$message.error('请填写专场标题')
				return
			}else if(!this.rowmsg.ImgUrl){
				this.$message.error('请上传专场图片')
				return
			}else if(!this.rowmsg.RelationId){
				this.$message.error('请选择关联项')
				return
			}else if(!this.rowmsg.StartTime||!this.rowmsg.EndTime){
				this.$message.error('请选择专场排期')
				return
			}else if(new Date(this.rowmsg.StartTime).getTime()>new Date(this.rowmsg.EndTime).getTime()){
				this.$message.error('结束时间不可小于开始时间')
				return
			}else if((this.rowmsg.ShowStartTime&&!this.rowmsg.ShowEndTime)||(!this.rowmsg.ShowStartTime&&this.rowmsg.ShowEndTime)){
				this.$message.error('请完善显示时间段')
				return
			}else if(new Date(this.rowmsg.ShowStartTime).getTime()>new Date(this.rowmsg.ShowEndTime).getTime()){
				this.$message.error('显示时间段有误，结束时间不能早于开始时间')
				return
			}
			let data = JSON.parse(JSON.stringify(this.rowmsg))
			data.Sort = data.Sort||0
			try{
				this.operationloading = true
				let res = await productproductSpecialSave({ProductSpecialInfo:data})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.addCancel()
					this.getList()
				}
			}finally{
				this.operationloading = false
			}
		}
		private addCancel(){
			this.operationShow = false
			this.rowmsg = {
				Id:0,
				IsDisplay:true,
				Title:'',
				ImgUrl:'',
				RelationType:2,
				StartTime:'',
				EndTime:'',
				RelationId:'',
				Sort:''
			}
		}
		// 获取分类列表
		private async getCategoryList() {
			let params: any = {
				Skip: 0,
				Take: 99999,
				Keywords: ''
			}
			try {
				const res: any = await productCategory(params);
				this.classityList = res.Result.Results;
			} catch (err) {
				// console.error('getProviderStatistics ===>', err)
			}
		}
		// 商品列表
		private async getProductList() {
			const params: any = {
				Skip: 0,
				Take: 99999,
				Keywords:''
			}
			try {
				const res: any = await productfilterBoxList(params)
				if (res.IsSuccess) {
					this.shoplist = res.Result;
				} 
			} catch (e) {
				console.log('productList ===>', e)
			}
		}

		private async getToken() {
			try {
				const res: any = await getOssToken({})
				this.token = {
					AccessKeySecret: res.access_key_secret,
					OSSAccessKeyId: res.access_key_id,
					SecurityToken: res.security_token
				}
			} catch (e) {
				// console.log('getOssToken ===>', e)
			}
		}
		private changetype(e){
			this.rowmsg.RelationId = ''
			this.rowmsg.RelationTypeValue = this.typelist.find(v=>v.value==e)?.label
			// console.log(e)
			if(e==1){
				this.getProductList()
			}else if(e==2){
				this.getCategoryList()
			}else if(e==3){
				this.getcustompage()
			}
		}
		private changeId(e){
			if(this.rowmsg.RelationType==1){
				this.rowmsg.RelationValue = this.shoplist.find(v=>v.Id==e)?.ProductName
			}else if(this.rowmsg.RelationType==2){
				this.rowmsg.RelationValue = this.classityList.find(v=>v.Id==e)?.CategoryName
			}else if(this.rowmsg.RelationType==3){
				this.rowmsg.RelationValue = this.pageList.find(v=>v.Id==e)?.PageName
			}
		}
		private handleUpload(list){
			this.rowmsg.ImgUrl = list[0]||''
		}

		// 清空搜索
		private clearSearch() {
			this.pageNo = 1;
			this.filterTime = ''
			this.getList();
		}

		private doSearch(){
			this.pageNo = 1;
			this.getList();
		}

		// 跳转到详情页面
		private async toDetail(type: string, val ? : any) {
			this.operationShow = true
			// this.operationloading = true
			if(val?.Id){
				this.rowmsg = JSON.parse(JSON.stringify(val))
			}
			await this.getCategoryList()
			await this.getProductList()
			await this.getcustompage()
			if(this.rowmsg.RelationType==1){
				this.rowmsg.RelationId = this.shoplist.find(v=>v.Id==this.rowmsg.RelationId)?.Id||''
			}else if(this.rowmsg.RelationType==2){
				this.rowmsg.RelationId = this.classityList.find(v=>v.Id==this.rowmsg.RelationId)?.Id||''
			}else if(this.rowmsg.RelationType==3){
				this.rowmsg.RelationId = this.pageList.find(v=>v.Id==this.rowmsg.RelationId)?.Id||''
			}
			// this.operationloading = false
		}

		// 修改页面
		private changePage(e) {
			this.pageNo = e;
			this.getList();
		}

		// 删除
		private async showDeleteDialog(item) {
			try{
				this.loading = true
				let res = await productproductSpecialDelete({Id:await item.Id})
				if(res.IsSuccess){
					this.$message.success('操作成功')
					this.getList()
				}
			}finally{
				this.loading = false
			}
		}
		private changeCurrent(val){
			this.pageNo = val;
			this.getList();
		}
		// 获取列表
		private async getList() {
			try {
				this.loading = true
				let data:any = {
					Skip: (this.pageNo-1)*this.pageSize,
					Take: this.pageSize,
					StartTime:'',
					EndTime:''
				}
				if(this.filterTime){
					var splitList = this.filterTime.split('/');
					data.StartTime = splitList[0];
					data.EndTime = splitList[1] ? (nextDay(splitList[1],1)) : '';
				}
				const res: any = await productproductSpecialList(data)
				this.list = res.Result.Results || [];
				this.total = res.Result.Total;
			} finally{
				this.loading = false
			}
		}

		// 设置状态
		private async handleShow(e: boolean, item: any) {
			this.rowmsg = item
			this.addConfirm()
		}
	}
